function c_col64_initScrollbar(section) {
  const row = section.querySelector('.c-col64-row');
  const track = section.querySelector('.c-col64-scrollbar');
  const thumb = section.querySelector('.c-col64-scrollbar-thumb');

  if (!row || !track || !thumb) return;

  const THUMB_EXTRA_WIDTH = 32;

  function update() {
    const trackWidth = track.clientWidth;
    const thumbWidth = Math.min(
      trackWidth,
      (row.clientWidth / row.scrollWidth) * trackWidth + THUMB_EXTRA_WIDTH
    );
    const maxScroll = row.scrollWidth - row.clientWidth;
    const maxThumbTranslate = trackWidth - thumbWidth;
    const scrollRatio = maxScroll > 0 ? row.scrollLeft / maxScroll : 0;

    track.style.display = maxScroll > 0 ? '' : 'none';
    thumb.style.width = `${thumbWidth}px`;
    thumb.style.transform = `translateX(${scrollRatio * maxThumbTranslate}px)`;
  }

  row.scrollLeft = 0;

  row.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  window.addEventListener('load', update);
  update();
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.c-col64-section').forEach(c_col64_initScrollbar);
});
